import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
} from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  AlertTitle,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  InputLabel,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { baseUrl, config, getUserData, requestID } from "../../common/utils";
import { Link } from "react-router-dom";
import { useBusinessContext } from "../../context/business-context";
export type User = {
  accountName: string;
  accountNumber: number;
  activeloans: number;
  area: string;
  bankName: string;
  businessAddress: string;
  bvn: number;
  churchAddress: string;
  dob: string; // Date of birth as a string
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  lga: string;
  middleName: string;
  nextOfKin: string;
  nextOfKinAddress: string;
  nextOfKinPhone: string;
  nextOfKinRelationship: string;
  parish: string;
  password: string; // This should not be displayed or handled in the UI
  pastorName: string;
  pastorPhone: string;
  phone: string;
  province: string;
  residentialAddress: string;
  savingAmount: string;
  securityAnswer1: string;
  securityAnswer2: string;
  securityQuestion1: string;
  securityQuestion2: string;
  status: number;
  titles: string;
  unitHeadName: string;
  unitHeadPhone: string;
  user_id: string;
  zone: string;
};

const LoanApproval = () => {
  const user_id = getUserData()?.user_id;
  const { selectedBusiness } = useBusinessContext()

  const { name } = useParams<{ name: string }>();
  const url = baseUrl(); // "http://localhost/rmfwarri";
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(
    null
  );
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [interestRate, setInterestRate] = useState<string>("");

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const fetchLoanApplications = async () => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "applyloans/getAllLoanApplications_caas",
        formData,
        config
      );
      console.log(response);
      const { data } = await response.data;
    
      setUsers(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    }
  };

  const filteredUsers = users?.filter(
    (user) =>
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.phone?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, users?.length - page * rowsPerPage);

  const handleApprove = async (userId: string, interestRate: string) => {
    // console.error( user_id);
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("loanID", userId);
      formData.append("user_id", user_id);
      formData.append("interestRate", interestRate);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "applyloans/loanApproval12_caas",
        formData,
        config
      );
      console.log(response);
      const data = await response.data;
      if (response.data.status == true) {
        setStatus({ loading: false, error: false });
        setAlertMsg(response.data.message);
        onShowAlert();
        setInterestRate("");
        fetchLoanApplications(); 
        setStatus({ loading: false, error: false });

      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
      fetchLoanApplications(); //  pls uncomment this dont forget pls

      // if(response.data.status == "true"){
      //         setUsers(users.map(user =>
      //   user.loanID === userId ? { ...user, status: '1' } : user
      // ));
      // }
    } catch (error) {
      console.error("Error approving loan:", error);
      setStatus({ loading: false, error: true });

    }
  };

  const handleReject = async (userId) => {
    try {
    } catch (error) {
      console.error("Error rejecting loan:", error);
    }
  };

  const handleOpenDialog = (userId: string, action: "approve" | "reject") => {
    setSelectedUserId(userId);
    setActionType(action);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUserId(null);
    setActionType(null);
  };

  const handleConfirmAction = () => {
    if (actionType && selectedUserId) {
      if (actionType === "approve") {
        handleApprove(selectedUserId, interestRate);
      } else if (actionType === "reject") {
        handleReject(selectedUserId);
      }
      handleCloseDialog();
    }
  };

  useEffect(() => {
    fetchLoanApplications();
    return () => {};
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {/* <Box
          sx={{
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <Link to={"/folder/loanRunning/loanRunning"}>
            <Button
              variant="contained"
              color="primary"
              slot="end"
              sx={{ m: 1, mr: 1 }}
            >
              View Running Loans
            </Button>
            <Divider orientation="horizontal" flexItem />
          </Link>
        </Box> */}

{showAlert && (
              <Alert severity={status.error ? "error" : "success"}>
                <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
                {alertMsg?.toUpperCase()}
              </Alert>
            )}

        <Container component="main" sx={{ mt: 4, mb: 2 }}>
          {/* <Paper elevation={3} sx={{ padding: 2 }}> */}
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Search by Email or Phone"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>S/N</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Loan Amount</TableCell>
                      <TableCell>Monthly Repayment</TableCell>
                      <TableCell>Duration</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredUsers
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((user, i) => (
                        <TableRow key={i}>
                          <TableCell>{page * rowsPerPage + i + 1}</TableCell>
                          <TableCell>{user.fullName}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.phone}</TableCell>
                          <TableCell>{user.loanAmount}</TableCell>
                          <TableCell>{user.monthlyRepay}</TableCell>
                          <TableCell>{user.loanDuration}</TableCell>
                          <TableCell>
                            {user.approval == "0" ? (
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                {user?.status == 0 ? (
                                  <Button
                                    variant="contained"
                                    disabled={
                                      user?.expected_guarantors !=
                                      user?.guarantee_log
                                    }
                                    color={"success"}
                                    onClick={() =>
                                      handleOpenDialog(user.loanID, "approve")
                                    }
                                    sx={{ mr: 1 }}
                                  >
                                    {user?.expected_guarantors !=
                                    user?.guarantee_log
                                      ? "Waiting"
                                      : "Push Loan"}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    color="warning"
                                    sx={{ mr: 1 }}
                                  >
                                    Pending
                                  </Button>
                                )}

                                {/* <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() =>
                                      handleOpenDialog(
                                        user.loanID,
                                        "reject"
                                      )
                                    }
                                  >
                                    Reject
                                  </Button> */}
                              </Box>
                            ) : (
                              <Button
                                variant="contained"
                                color="warning"
                                sx={{ mr: 1 }}
                              >
                                Pending
                              </Button>
                            )}
                            {emptyRows < 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={3} />
                              </TableRow>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={filteredUsers?.length ?? 0}
                // count={users?.length ?? 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
          {/* </Paper> */}
        </Container>

        {showAlert && (
          <Alert severity={status.error ? "error" : "success"}>
            <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )}

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
        >
          <DialogTitle id="confirmation-dialog-title">
            Confirm Action
          </DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to {actionType} this loan application?
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "90%",

                marginTop: "1%",
                // marginLeft:'40%',
                "& > :not(style)": { m: 4 },
              }}
            >
              <FormControl fullWidth>
                {/* <InputLabel id="demo-simple-select-label"> </InputLabel> */}
                <TextField
                  // required
                  fullWidth
                  type="number"
                  label="Enter Interest Rate Value"
                  margin="normal"
                  value={interestRate}
                  onChange={(e) => setInterestRate(e.target.value)}
                  // {...register("otherReason")}
                  // error={!!errors.otherReason}
                  // helperText={errors.otherReason?.message}
                />
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              color={actionType === "approve" ? "success" : "error"}
              autoFocus
            >
              {actionType === "approve" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

       
      </IonContent>
    </IonPage>
  );
};

export default LoanApproval;
